module.exports = __webpack_public_path__ + "static/media/liabilityCar.1ba601c8.svg";